module.exports = __webpack_public_path__ + "static/media/logo-hmi-white.2b90a9ed.png";